import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ChatInputComponent} from "./chat-input.component";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import { MaintenancePopUpComponent } from './maintenance-pop-up/maintenance-pop-up.component';
import {MatDialogModule} from '@angular/material/dialog';
import { Home365LoaderModule } from "../loader/home365-loader.module";



@NgModule({
  declarations: [ChatInputComponent, MaintenancePopUpComponent],
  exports: [ChatInputComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    Home365LoaderModule
  ]
})
export class ChatInputModule { }
